export interface GetAdminUserResponse {
    admin_id: number;
    admin_name: string;
    account: string;
    permissions: string[];
    enabled?: boolean;
    annual_award_reviewer_id?: number;
    annual_award_reviewer_name?: string;
}

import { request } from '@umijs/max';

export interface RegisterRequest {
    account: string;
    password: string;
    admin_name: string;
    permissions: string[];
    enabled?: boolean;
    account_type: string;
    judge_role?: string;
    annual_award_reviewer_id?: number;
}

export interface RegisterResponse {
    admin_id: number;
}

export interface AdminUserListItem {
    admin_id: number;
    admin_name: string;
    account: string;
    permissions: string[];
    enabled?: boolean;
    account_type?: string;
    judge_role?: string;
    annual_award_reviewer_id?: number;
    annual_award_reviewer_name?: string;
}

export interface GetAdminUserListResponse {
    data: AdminUserListItem[];
    total: number;
    success: boolean;
}

export async function registerAdminUser(data: RegisterRequest) {
    return request<RegisterResponse>('/admin/user/', {
        method: 'POST',
        data,
    });
}

// 取得管理員列表
export async function getAdminUserList(params: {
    pageSize?: number;
    current?: number;
    username?: string;
    email?: string;
    enabled?: string;
    accountType?: string; // content_manager, judge_manager'
    judgeRole?: string;
}) {
    const { ...query } = params;
    return request<GetAdminUserListResponse>('/admin/user/', {
        method: 'GET',
        params: query,
    });
}

// 取得單一管理員資訊
export async function getAdminUser(adminID: string) {
    return request<GetAdminUserResponse>(`/admin/user/${adminID}`, {
        method: 'GET',
    });
}

// 更新管理員資訊
export interface UpdateAdminUserRequest {
    account: string;
    password: string;
    admin_name: string;
    permissions: string[];
    enabled?: boolean;
    account_type?: string;
    judge_role?: string;
    annual_award_reviewer_id?: number;
}

export async function updateAdminUser(adminID: string, data: UpdateAdminUserRequest) {
    return request<void>(`/admin/user/${adminID}`, {
        method: 'PUT',
        data,
    });
}

// 刪除管理員
export async function deleteAdminUser(adminID: string) {
    return request<void>(`/admin/user/${adminID}`, {
        method: 'DELETE',
    });
}

// 上傳檔案
export interface UploadAdminFileResponse {
    file_path: string;
}

export async function uploadFile(file: File, dir: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('dir', dir);
    return request<UploadAdminFileResponse>('/admin/upload', {
        method: 'POST',
        data: formData,
        requestType: 'form',
    });
}

export interface AnnualAwardReviewer {
    id: number;
    name: string;
    enabled: boolean;
}

export async function getAnnualAwardReviewersWithoutAdminID() {
    return request<AnnualAwardReviewer[]>('/admin/annual_award_reviewers/without_admin_id', {
        method: 'GET',
    });
}
